import { NgModule } from '@angular/core';
import {
	BciCardModule,
	BciFormMsgModule,
	BciSpinnerModule,
	BciWkButtonModule,
	BciWkCheckboxModule,
	BciWkInputMoneyModule,
	BciWkInputPhoneModule,
	BciWkInputTextModule,
	BciWkInputPasswordModule,
	BciWkModalModule,
	BciWkSelectModule,
	BciWkSnackbarsModule,
	BciWkStepperHorizontalModule,
	BciWkTypographyModule,
	BciWkDatepickerModule,
	BciTableModule,
	BciWkAlertModule,
	BciWkTooltipModule,
} from '@bci/webkitbci';

@NgModule({
	imports: [
		BciWkTypographyModule,
		BciCardModule,
		BciWkStepperHorizontalModule,
		BciSpinnerModule,
		BciFormMsgModule,
		BciWkSelectModule,
		BciWkInputMoneyModule,
		BciWkInputTextModule,
		BciWkInputPhoneModule,
		BciWkInputPasswordModule,
		BciWkButtonModule,
		BciWkCheckboxModule,
		BciWkSnackbarsModule,
		BciWkDatepickerModule,
		BciWkModalModule,
		BciTableModule,
		BciWkAlertModule,
		BciWkTooltipModule,
	],
	exports: [
		BciWkTypographyModule,
		BciCardModule,
		BciWkStepperHorizontalModule,
		BciSpinnerModule,
		BciFormMsgModule,
		BciWkSelectModule,
		BciWkInputMoneyModule,
		BciWkInputTextModule,
		BciWkInputPhoneModule,
		BciWkInputPasswordModule,
		BciWkButtonModule,
		BciWkCheckboxModule,
		BciWkSnackbarsModule,
		BciWkDatepickerModule,
		BciWkModalModule,
		BciTableModule,
		BciWkAlertModule,
		BciWkTooltipModule,
	],
})
export class BciWkModule {}
